<template>
  <v-dialog v-model="open" scrollable max-width="1200">
    <v-card v-if="subject_data">
      <v-card-title
        >{{ $t("pre_regis_add_subject.subject_id") }} :
        {{ subject_data.subject_id }}</v-card-title
      >
      <v-divider></v-divider>
      <v-card-text>
        <h1 class="mt-3 deep-orange--text">
          {{ subject_data.subject_name_th }}
        </h1>
        <h2 class="brown--text">
          {{ subject_data.subject_name_en }}
        </h2>
        <p
          class="pt-3"
          style="text-indent: 30px; font-size: 16px;"
        >
          {{ subject_data.detail | stripHTML }}
        </p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click="open = false">
          {{ $t("pre_regis_add_subject.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import genericProvider from "@/services/generic.provider.js";
const genericService = new genericProvider();

export default {
  name: "SubjectDialog",
  props: {
    levelId: {
      type: [String, Number],
      default: 1,
    },
  },
  data: () => ({
    open: false,
    subject_data: null,
  }),

  computed: {},

  methods: {
    async fetch_subject(subject_id, levelId = this.levelId) {
      const data = await genericService.getRegistrarSubject(levelId || 1, subject_id);
      if (data[0]) {
        this.subject_data = data[0];
      }
    },

    show_item_detail(subject_id, levelId = this.levelId) {
      this.subject_data = null;
      this.fetch_subject(subject_id, levelId);
      this.open = true;
    },
  },
};
</script>

<style></style>
